import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder,
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
declare var $: any;

@Component({
  selector: 'app-entry-detail',
  templateUrl: './entry-detail.component.html',
  styleUrls: ['./entry-detail.component.css']
})
export class EntryDetailComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  book: any = null;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // arrays
  movement: any = null;
  detail: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private warehouseService: WarehouseService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.editData();
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id = null) {
    this.warehouseService.detail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data;
        this.movement = result.movement;
        this.detail = result.detail;
      }
    });
  }

  printer(){
    (<any>$('#body')).printThis({
      importCSS: true,
  });
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/almacen/entradas/lista']);
  }
}
